import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'
import { RootState } from 'redux/store'
import { openModal, ModalContent } from './globalModal'

interface GlobalErrorState {
    message: string | null
}

export const initialState: GlobalErrorState = {
    message: null,
}

const globalErrorSlice = createSlice({
    name: 'globalError',
    initialState,
    reducers: {
        resetState: _ => initialState,
        setError: (_, { payload: message }: PayloadAction<string>) => {
            return { message: message }
        },
    },
})

const { actions, reducer } = globalErrorSlice // Extract the action creators object and the reducer
export default reducer

//Selectors
export const getGlobalErrorState = (store: RootState) => store.globalError
export const getErrorMessage = createSelector(getGlobalErrorState, globalError => globalError.message)

//Action creators
export const { resetState, setError } = actions

//Thunks
export const showError = errorMessage => async dispatch => {
    dispatch(setError(errorMessage))
    dispatch(openModal({ content: ModalContent.ERROR }))
}
